import { useSelector } from 'react-redux';
import { useMusicPlayer } from '../../contexts/MusicPlayerContext';
import { authSelector } from '../../features/auth/slice';

export default function Footer() {
  const { lyricsBarVisible } = useMusicPlayer();
  const {
    distributorId,
    distributorName,
    distributorLogo,
    distributorTheme,
    distributorBusinessNumber,
    distributorRepresentative,
    distributorAddress,
  } = useSelector(authSelector.selectAuthState);
  const isPink = !distributorId || distributorId === 1;
  const isDark = distributorTheme === 'dark';

  return (
    <footer
      className={`border-t mt-8 ${lyricsBarVisible ? 'pb-[136px] sm:pb-[104px]' : 'pb-[100px] sm:pb-[70px]'}`}
      style={{
        background: isDark ? '#0a101e' : '#f8fafc',
        borderColor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.08)',
      }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            {distributorLogo
              ? <img src={distributorLogo} alt={distributorName} className="h-6 w-auto mb-3 opacity-70" />
              : <p className={`text-base font-bold mb-3 ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>{distributorName || 'p!nk'}</p>
            }
            {isPink ? (
              <p className={`text-xs leading-relaxed ${isDark ? 'text-slate-500' : 'text-slate-400'}`}>
                상호: 핑크페이퍼 · 대표: 김태연 외 1명
                <br />
                사업자등록번호: 688-07-02108
                <br />
                경기도 남양주시 다산중앙로19번길 21 블루웨일 지식산업센터 1차 F동 307호
              </p>
            ) : (
              <p className={`text-xs leading-relaxed ${isDark ? 'text-slate-500' : 'text-slate-400'}`}>
                {distributorRepresentative && <span>대표: {distributorRepresentative}<br /></span>}
                {distributorBusinessNumber && <span>사업자등록번호: {distributorBusinessNumber}<br /></span>}
                {distributorAddress && <span>{distributorAddress}</span>}
                {!distributorRepresentative && !distributorBusinessNumber && !distributorAddress && (
                  <span>{distributorName} 정산 시스템</span>
                )}
              </p>
            )}
          </div>
          <div className={`text-xs text-left sm:text-right leading-relaxed ${isDark ? 'text-slate-600' : 'text-slate-400'}`}>
            {isPink ? (
              <>
                <p className="text-sm font-bold tracking-wide">TEL: 1844-2549</p>
                <p>EMAIL: pink@impink.co.kr</p>
                <div className="mt-3 flex items-center gap-2 sm:justify-end">
                  <span className={`text-[11px] ${isDark ? 'text-slate-600' : 'text-slate-400'}`}>패밀리사이트</span>
                  <a
                    href="https://pinkpaper.kr"
                    target="_blank"
                    rel="noreferrer"
                    className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-[11px] font-semibold transition-colors ${
                      isDark ? 'bg-sky-500/15 text-sky-400 hover:bg-sky-500/30' : 'bg-sky-50 text-sky-600 hover:bg-sky-100'
                    }`}>
                    핑크페이퍼
                  </a>
                  <a
                    href="https://kccm.app"
                    target="_blank"
                    rel="noreferrer"
                    className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-[11px] font-semibold transition-colors ${
                      isDark ? 'bg-sky-500/15 text-sky-400 hover:bg-sky-500/30' : 'bg-sky-50 text-sky-600 hover:bg-sky-100'
                    }`}>
                    KCCM
                  </a>
                </div>
                <p className="mt-2">© 2023 pinkpaper. All rights reserved.</p>
              </>
            ) : (
              <p className="mt-2">Powered by <span className="font-semibold">KDIST</span></p>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
